// // import React from 'react';
// // import './vyn_hero.css';
// // import vynlogo from '../../img/des_sec/hero_cont_1.svg'; // Adjust the path as necessary

// // const VynHero = () => {
// //   return (
// //     <section className="hero-container-wm">
// //       <div className="hero-content-wm">
// //         <div className="logo-container-wm">
// //           <img 
// //             src={vynlogo}
// //             alt="VYN Logo" 
// //             className="logo-image-wm" 
// //           />
// //         </div>
        
// //         <h1 className="hero-title-wm">
// //           <span className='hero-title-wm2'>Transforming</span> <span className="highlight-text-wm">Workforce management</span>
// //         </h1>
        
// //         <p className="hero-description-wm">
// //           Empowering you to manage contract labour with verified digital onboarding, real-time background checks, compliance management, proactive alerts, and more.
// //         </p>
// //       </div>
      
// //       {/* <div className="wave-bottom-wm"></div> */}
// //     </section>
// //   );
// // };

// // export default VynHero;

// import React from 'react';
// import { useSpring, animated } from 'react-spring';
// import { useInView } from 'react-intersection-observer';
// import './vyn_hero.css';
// import vynlogo from '../../img/des_sec/hero_cont_1.svg'; // Adjust the path as necessary

// const VynHero = () => {
//   const [ref, inView] = useInView({
//     triggerOnce: false,
//     threshold: 0.1,
//   });

//   const fadeIn = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0)' : 'translateY(20px)',
//     config: { duration: 800 },
//   });

//   const titleAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0)' : 'translateY(-20px)',
//     config: { duration: 1000 },
//   });

//   const textAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'translateY(0)' : 'translateY(10px)',
//     config: { duration: 1000 },
//   });

//   const logoAnimation = useSpring({
//     opacity: inView ? 1 : 0,
//     transform: inView ? 'scale(1)' : 'scale(0.9)',
//     config: { duration: 1000 },
//   });

//   return (
//     <section className="hero-container-wm" ref={ref}>
//       <animated.div className="hero-content-wm" style={fadeIn}>
//         <animated.div className="logo-container-wm" style={logoAnimation}>
//           <img 
//             src={vynlogo}
//             alt="VYN Logo" 
//             className="logo-image-wm" 
//           />
//         </animated.div>

//         <animated.h1 className="hero-title-wm" style={titleAnimation}>
//           <span className='hero-title-wm2'>Transforming</span> <span className="highlight-text-wm">Workforce management</span>
//         </animated.h1>

//         <animated.p className="hero-description-wm" style={textAnimation}>
//           Empowering you to manage contract labour with verified digital onboarding, real-time background checks, compliance management, proactive alerts, and more.
//         </animated.p>
//       </animated.div>
//       {/* <div className="wave-bottom-wm"></div> */}
//     </section>
//   );
// };

// export default VynHero;

import React from 'react';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';
import './vyn_hero.css';
import vynlogo from '../../img/des_sec/hero_cont_1.svg'; // Adjust the path as necessary
import { useNavigate } from 'react-router-dom';
const VynHero = () => {
  const [ref, inView] = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

   const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/partnerVyn');
  };

  const fadeIn = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(20px)',
    config: { duration: 800 },
  });

  const titleAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(-20px)',
    config: { duration: 1000 },
  });

  const textAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(10px)',
    config: { duration: 1000 },
  });

  const logoAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'scale(1)' : 'scale(0.9)',
    config: { duration: 1000 },
  });

  const buttonAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(20px)',
    config: { duration: 1000, delay: 300 },
  });

  return (
    <section className="hero-container-wm" ref={ref}>
      <animated.div className="hero-content-wm" style={fadeIn}>
        <animated.div className="logo-container-wm" style={logoAnimation}>
          <img 
            src={vynlogo}
            alt="VYN Logo" 
            className="logo-image-wm" 
          />
        </animated.div>

        <animated.h1 className="hero-title-wm" style={titleAnimation}>
          <span className='hero-title-wm2'>Transforming</span> <span className="highlight-text-wm">Workforce management</span>
        </animated.h1>

        <animated.p className="hero-description-wm" style={textAnimation}>
          Take full control of your workforce with VYN. From seamless digital onboarding and real-time compliance to intelligent insights and Vinny, your dedicated AI assistant. We give you the clarity and automation needed to scale your operations without the stress.
        </animated.p>

        <animated.div className="hero-button-container" style={buttonAnimation}>
          <button className="outlined-button" onClick={handleButtonClick}>
            Partner with us
          </button>
        </animated.div>
      </animated.div>
      {/* <div className="wave-bottom-wm"></div> */}
    </section>
  );
};

export default VynHero;